import openDatabase from "./openDatabase";

const clearStore = async (storeName, dbName = "ERP_DB", dbVersion = 1) => {
  try {
    // Open the database
    const db = await openDatabase(dbName, storeName, dbVersion);

    // Start a readwrite transaction to the specified store
    const transaction = db.transaction(storeName, "readwrite");
    const store = transaction.objectStore(storeName);

    // Clear all data in the store
    const clearRequest = store.clear();

    // Wait for the clear operation to complete
    await new Promise((resolve, reject) => {
      clearRequest.onsuccess = () => resolve();
      clearRequest.onerror = (event) => reject(event.target.error);
    });

    // console.log("Client data cleared successfully.");
  } catch (error) {
    console.error("Error clearing client data:", error);
    throw error; // Optionally rethrow the error for further handling
  }
};

export default clearStore;
